import { TweenMax } from "gsap/umd/TweenMax";
import { TimelineMax } from "gsap";

'use strict';
jQuery($ => {

class ProductTestimonials {
    categories = [];
    timelines = [];

    scrolled = 0;

    padding = 100;

	constructor(container) {
        this.wrapper = $(container).find('.gecko-builder-product-testimonials__wrapper');

        this.wrapper.find('.gecko-builder-product-testimonials__category').each((i, el) => {
            this.initCategory($(el));
        });

        const resizeWindow = this.debounce(() => {
            // console.log('Resized window, debounced');
            this.reflowCategories();
        }, 200);
        window.addEventListener('resize', resizeWindow);

        const updateScrolled = this.debounce(() => {
            // console.log('Scrolled, debounce');
        }, 200);
        window.addEventListener('scroll', updateScrolled);
    }

    debounce(func, wait, immediate) {
        var timeout;
        return function () {
            var context = this, args = arguments;

            var later = () => {
                timeout = null;
                if (!immediate) func.apply(context, args);
            }

            var callNow = immediate && !timeout;
            clearTimeout(timeout);
            timeout = setTimeout(later, wait);
            if (callNow) func.apply(context, args);
        };
    }

    reflowCategories() {
        this.wrapper.find('.gecko-builder-product-testimonials__category').each((i, el) => {
            this.reflowCategory(i)
        });
    }

    reflowCategory(index) {
        let category = this.categories[index];

        this.setSizes(category);

        // Clear the animation if note is active
        category.timeline.reverse();

        // Set initial state of elements
        TweenMax.to(category.note, 0.2, {
            position: 'absolute',
            zIndex: 510,
            top: 0,
            left: 0,
            x: category.coords.x,
            y: category.coords.y,
            width: category.size.width,
            height: category.size.height,
        });
        TweenMax.to(category.overlay, 0.2, {
            position: 'absolute',
            zIndex: 500,
            opacity: 0,
            top: 0,
            left: 0,
            x: 0,
            y: 0,
            width: this.wrapper.outerWidth(),
            height: this.wrapper.outerHeight(),
        });

        category.timeline = this.createCategoryTimeline(category);
        category.rotateTimeline = this.createCategoryRotateTimeline(category);
    }

    resetNotePosition(category) {
        // Set initial state of elements
        TweenMax.set(category.note, {
            position: 'absolute',
            zIndex: 510,
            top: 0,
            left: 0,
            x: category.coords.x,
            y: category.coords.y,
            width: category.size.width,
            height: category.size.height,
        });
        TweenMax.set(category.overlay, {
            position: 'absolute',
            zIndex: 500,
            opacity: 0,
            top: 0,
            left: 0,
            x: 0,
            y: 0,
            width: this.wrapper.outerWidth(),
            height: this.wrapper.outerHeight(),
        });
    }

    initCategory(category) {
        // 15rem set initial w/h of the note elements (240px)
        category.newRight = 240;

        // Gather elements to animate
        category.note = category.find('.gecko-builder-product-testimonials__note');
        category.shadow = category.find('.gecko-builder-product-testimonials__shadow');
        category.overlay = category.find('.gecko-builder-product-testimonials__overlay');
        category.closeButton = category.find('.gecko-builder-product-testimonials__close');
        category.quotes = category.find('.gecko-builder-product-testimonials__quotes');
        category.titleContainer = category.find('.gecko-builder-product-testimonials__category-title');
        category.titleIcon = category.find('.gecko-builder-product-testimonials__category-icon');
        category.titleText = category.find('.gecko-builder-product-testimonials__title');
        category.quote = category.find('.gecko-builder-product-testimonials__quote');
        category.pagination = category.find('.swiper-pagination');

        // Create a swiper element for the quotes
        category.swiper = new Swiper(category.quotes.find('.swiper-container'), {
            navigation: {
                nextEl: '.swiper-button-next',
                prevEl: '.swiper-button-prev',
            },
            pagination: {
                el: category.pagination,
                type: 'bullets',
                clickable: true,
            },
        });

        this.categories.push(category);

        this.setSizes(category);

        this.resetNotePosition(category);

        category.timeline = this.createCategoryTimeline(category);
        category.rotateTimeline = this.createCategoryRotateTimeline(category);


        // Click events
        category.find('.gecko-builder-product-testimonials__category-title').on('click', (e) => {
            e.preventDefault();
            if (!category.note.hasClass('gecko-builder-product-testimonials__note--active')) {
                this.scrollPosition = $(window).scrollTop();

                const headerHeight = $('body > header:visible').outerHeight();
                // $('html, body').animate({
                //     scrollTop: this.wrapper.offset().top - headerHeight - 16,
                // }, 500);
                category.timeline.play('start');
            }
        });

        // Hide the expanded note by reversing the timeline
        category.overlay.on('click', (e) => {
            e.preventDefault();
            category.timeline.reverse();
            // $('html, body').animate({
            //     scrollTop: this.scrollPosition,
            // }, 500);
        });

        // Rotate event
        category.note.on('mouseover', (e) => {
            if (!category.note.hasClass('gecko-builder-product-testimonials__note--active')) {
                TweenMax.to(category.note, 0.2, {
                    rotation: 3,
                });
            }
        });
        category.note.on('mouseout', (e) => {
            if (!category.note.hasClass('gecko-builder-product-testimonials__note--active')) {
                TweenMax.to(category.note, 0.2, {
                    rotation: 0,
                });
            }
        });
    }

    setSizes(category) {
        category.size = {
            width: category.outerWidth(),
            height: category.outerHeight(),
        };

        category.coords = {
            x: category.position().left,
            y: category.position().top,
        };
    }

    createCategoryRotateTimeline(category) {
        const timeline = new TimelineLite({
            paused: true
        });

        timeline.addLabel('start');

        timeline.to(category.note, 0.2, {
            rotation: 3,
        });

        return timeline;
    }

    createCategoryTimeline(category) {
        const timeline = new TimelineLite({
            paused: true,
            onStart: () => {
                this.scrolled = $(window).scrollTop() - $('body > header:visible').outerHeight();
            },
            onUpdate: () => {
                const pos = category.titleContainer.position().left;

                const winWidth = $(window).width();
                if (winWidth >= 900) {
                    category.newRight = category.titleContainer.outerWidth() + (pos * 1.5);
                } else if (winWidth < 900 && winWidth >= 480) {
                    category.newRight = 100;
                } else {
                    category.newRight = 48;
                }

                this.scrolled = $(window).scrollTop() - $('body > header:visible').outerHeight();
                // console.log(this.scrolled);

                TweenMax.to(category.quote, 0.2, {
                    marginLeft: category.newRight,
                    opacity: 1,
                });
                TweenMax.to(category.pagination, 0.2, {
                    marginLeft: category.newRight,
                });
            }
        });

        // timeline.timeScale(1.5);
        // Create a label to define start point
        timeline.addLabel('start');
        // timeline.timeScale(0.25);

        // Start the note rotated, bring it above the other notes
        timeline.set(category.note, {
            rotation: 3,
            zIndex: '+=20',
            className: "+=gecko-builder-product-testimonials__note--active",
        });
        // Raise the overlay
        timeline.set(category.overlay, {
            zIndex: '+=20',
        });

        timeline.set(category.quotes, {
            width: '100%',
        });

        // Fade in the overlay
        timeline.to(category.overlay, 0.5, {
            ease: Power2.easeInOut,
            opacity: 1,
        }, 'start');

        // Hide the shadow element
        timeline.to(category.shadow, 0.5, {
            ease: Power2.easeInOut,
            scale: 0,
            transformOrigin: 'left bottom',
        }, 'start');

        // Display the close icon
        timeline.to(category.closeButton, 0.5, {
            ease: Power2.easeInOut,
            scale: 1,
            y: '-=16',
            transformOrigin: 'center',
        }, 'start');


        const headerHeight = $('body > header:visible').outerHeight();
        const winHeight = $(window).height() - headerHeight;
        const winWidth = $(window).width();

        let noteHeight = this.wrapper.outerHeight();
        if (noteHeight >= winHeight) {
            noteHeight = winHeight - (this.padding / 2);
        }
        noteHeight = noteHeight - this.padding;


        timeline.to(category.note, 0.2, {
            y: this.scrolled + this.padding / 2,
        }, 'start');

        // Expand the note element
        timeline.to(category.note, 0.5, {
            ease: Power2.easeInOut,
            x: this.padding / 2,
            top: 0,
            // y: '-=50%',
            height: noteHeight,
            width: this.wrapper.outerWidth() - this.padding,
            rotation: 0,
        }, 'start');

        if (winWidth >= 900) {
            timeline.to(category.quotes, 0.25, {
                ease: Power2.easeInOut,
                opacity: 1,
            }, 'start+=0.1');
        } else {
            timeline.to(category.quotes, 0.25, {
                ease: Power2.easeInOut,
                top: '35%',
                height: '65%',
                opacity: 1,
            }, 'start+=0.1');
        }


        if (winWidth >= 900) {
            timeline.to(category.titleContainer, 0.25, {
                ease: Power2.easeInOut,
                width: '+=100',
                x: '+=80',
            }, 'start+=0.1');
        } else {
            timeline.to(category.titleContainer, 0.25, {
                ease: Power2.easeInOut,
                width: '100%',
                height: '35%',
            }, 'start+=0.1');
        }


        if (winWidth >= 900) {
            timeline.to(category.titleText, 0.25, {
                ease: Power2.easeInOut,
                y: '-=90',
                color: '#FFFFFF',
                fontSize: '2.4rem',
            }, 'start+=0.1');

            timeline.to(category.titleIcon, 0.25, {
                ease: Power2.easeInOut,
                y: '+=40',
            }, 'start+=0.1');
        } else if (winWidth < 900 && winWidth >= 480) {
            timeline.to(category.titleText, 0.25, {
                ease: Power2.easeInOut,
                x: '+=90',
                color: '#FFFFFF',
                fontSize: '2.2rem',
                width: '40%',
            }, 'start+=0.1');

            timeline.to(category.titleIcon, 0.25, {
                ease: Power2.easeInOut,
                height: '80%',
                top: '10%',
                y: 0,
                x: '-=100',
            }, 'start+=0.1');
        } else {
            timeline.to(category.titleText, 0.25, {
                ease: Power2.easeInOut,
                top: '60%',
                height: '30%',
                color: '#FFFFFF',
                fontSize: '1.6rem',
            }, 'start+=0.1');

            timeline.to(category.titleIcon, 0.25, {
                ease: Power2.easeInOut,
                height: '50%',
                top: '10%',
                y: 0,
            }, 'start+=0.1');
        }


        timeline.to(category.titleIcon.find('svg *'), 0.25, {
            ease: Power2.easeInOut,
            fill: '#FFFFFF',
        }, 'start+=0.1');

        // Swiper update on onComplete event
        timeline.eventCallback("onComplete", () => {
            category.swiper.update();
            category.swiper.autoplay.start();
            TweenMax.to(category.note, 0.2, {
                rotation: 0,
            });
        });
        // Unrotate on onReverseComplete event
        timeline.eventCallback("onReverseComplete", () => {
            category.swiper.autoplay.stop();
            TweenMax.to(category.note, 0.2, {
                rotation: 0,
            });
        });

        return timeline;
    }
}

$(document).ready(() => {
	// Find the 'Devices' section on document ready
    const testimonials = document.querySelectorAll('.gecko-builder-product-testimonials');

	if (testimonials) {
        // Set up the canvas if element exists
        for (const testimonial in testimonials) {
            if (testimonials.hasOwnProperty(testimonial)) {
                const element = testimonials[testimonial];
                const productTestimonial = new ProductTestimonials(element);
            }
        }
    }
});

});